import { urlBaseApi } from '../consts';



export const create = (token, body) => {
  return {
    url: `${urlBaseApi}/task-prices/create`,
    method: 'POST',
    data: body,
    headers: {
      Authorization: 'Bearer ' + token
    }
  };
};

export const list = (token,page,limit) => {
  return {
    url: `${urlBaseApi}/task-prices/get-all?page=${page}&limit=${limit}`,
    method: 'GET',
    headers: {
      Authorization: 'Bearer ' + token
    }
  };
};

export const dropdown = (token) => {
  return {
    url: `${urlBaseApi}/task-prices/dropdown`,
    method: 'GET',
    headers: {
      Authorization: 'Bearer ' + token
    }
  };
};

export const one = (token, id) => {
  return {
     url: `${urlBaseApi}/task-prices/get/${id}`,
    method: 'GET',
    headers: {
      Authorization: 'Bearer ' + token
    }
  };
};

export const update = (token, id, body) => {
  return {
    url: `${urlBaseApi}/task-prices/update/${id}`,
    method: 'PUT',
    data: body,
    headers: {
      Authorization: 'Bearer ' + token
    }
  };
};

export const remove = (token,id) => {
  return {
    url: `${urlBaseApi}/task-prices/delete/${id}`,
    method: 'DELETE',
    headers: {
      Authorization: 'Bearer ' + token
    }
  };
};